import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createReferrals, type CreateReferralRequest } from '../api/referralsApi';

/**
 * Hook to create provider referrals
 * Feature 001: FA Dashboard Provider Referrals
 *
 * @returns Mutation object for creating referrals
 */
export function useReferProvider() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateReferralRequest) => createReferrals(data),
    onSuccess: (_, variables) => {
      // Invalidate provider referrals query to refresh "Already referred" state
      queryClient.invalidateQueries({
        queryKey: ['advisor', 'referrals', 'provider', variables.providerId],
      });
    },
  });
}
